module.exports = __webpack_public_path__ + "static/media/facebook_pos_icon.76a42deb.svg";